<template>
  <b-card
    :class="cardClassModifiers"
    class="result-card"
  >
    <template #header>
      <component
        v-if="headerComponent"
        :is="headerComponent"
        :data="value"
        :alarmed="alarmed"
      />
      <template v-else>
        <s-icon
          v-if="alarmed"
          name="exclamation-triangle"
          class="text-red p-1 border-red mr-1"
        />
        <label
          :class="alarmed ? 'text-red' : 'text-green'"
          class="mb-0"
        >
          {{ $t(`enums.engineering.chromatography.methods.${rule}.${method}`) }}
        </label>
      </template>
    </template>
    <component
      :is="contentComponent"
      :data="value"
      :alarmed="alarmed"
      :rule="rule"
    />
    <template
      #footer
      v-if="footerComponent"
    >
      <component
        :is="footerComponent"
        :data="value"
        :alarmed="alarmed"
      />
    </template>
  </b-card>
</template>
<style lang="sass" scoped>
.result-card
  min-height: 13.5rem
  &_normal
    width: 36rem
  &_large
    width: 74rem
  ::v-deep >
    .card-header
      border-bottom: 0
      font-size: 1.1em
    .card-body
      padding-top: 0
      padding-bottom: 0
    .card-footer
      border-top: 0
    .card-header,
    .card-body,
    .card-footer
      background-color: var(--color-table-body-accent-bg)
</style>
<script>
import cardContents from './cardContents';
import NotExecutedContent from './cardContents/NotExecuted';

export default {
  props: {
    method: String,
    alarmed: Boolean,
    executed: Boolean,
    value: null,
    rule: String,
  },
  computed: {
    cardClassModifiers() {
      return {
        'border-red': this.alarmed,
        'result-card_normal': this.cardDefinition.size == null
          || this.cardDefinition.size === 'normal',
        'result-card_large': this.cardDefinition.size === 'large',
      };
    },
    headerComponent() {
      return cardContents[this.rule][this.method].header;
    },
    cardDefinition() {
      return cardContents[this.rule][this.method];
    },
    contentComponent() {
      if (this.executed) {
        return this.cardDefinition.content;
      }

      return this.notExecutedContentComponent;
    },
    footerComponent() {
      if (!this.executed) {
        return null;
      }
      return this.cardDefinition.footer;
    },
    notExecutedContentComponent() {
      return this.cardDefinition.notExecuted || NotExecutedContent;
    },
  },
};
</script>
